import {jsx} from 'panel';

import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectEl} from 'common/components/select';
import {EntryPart} from 'common/widgets/query-entry-section/types';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';

import type {FilterEntryRow} from '../index';

export function FilterObjectValue(this: FilterEntryRow) {
  const {activeEntry, entryPart} = this.section.state;
  const isOpen = activeEntry === this.index && entryPart === EntryPart.FilterValue;

  const [, operator, ...labelParts] = this.filter.getLabelParts();
  const label = [operator.label, ...labelParts.map((part) => part.label)].join(` `);

  return (
    <SelectEl
      class={{
        'is-placeholder': !this.filter.isValid(),
      }}
      attrs={{
        elref: `filterValueSelect`,
        open: isOpen,
        theme: `select`,
        'selected-option': this.filter.isValid() ? label : `Select value...`,
      }}
      on={{
        menuChange: (ev) => this.section.helpers.onSelectMenuChange(ev, this.index, EntryPart.FilterValue),
      }}
    >
      {isOpen && (
        <PropertyValuesScreenEl
          attrs={{
            elref: `filterValue`,
            slot: `body`,
            'display-value-only': true,
            'event-names': this.section.attr(`event-names`),
            'property-filter': this.filter.getAttributes(),
            'project-id': this.section.attr(`project-id`),
            'workspace-id': this.section.attr(`workspace-id`),
          }}
          on={{
            commitPropertyFilter: (ev: CommitPropertyFilterEvent) => this.updateEntry(ev.detail.propertyFilter),
          }}
        />
      )}
    </SelectEl>
  );
}
